"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _q = _interopRequireDefault(require("q"));

var _immutable = require("immutable");

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _ObjectTypes = _interopRequireDefault(require("playbooks-modal/constants/ObjectTypes"));

var baseUrl = 'properties/v2';
var _default = {
  fetchContactProperties: function fetchContactProperties() {
    return _apiClient.default.get(baseUrl + "/" + _ObjectTypes.default.CONTACT + "/groups?includeProperties=true");
  },
  fetchCompanyProperties: function fetchCompanyProperties() {
    return _apiClient.default.get(baseUrl + "/" + _ObjectTypes.default.COMPANY + "/groups?includeProperties=true");
  },
  fetchDealProperties: function fetchDealProperties() {
    return _apiClient.default.get(baseUrl + "/" + _ObjectTypes.default.DEAL + "/groups?includeProperties=true");
  },
  fetchTicketProperties: function fetchTicketProperties() {
    return _apiClient.default.get(baseUrl + "/" + _ObjectTypes.default.TICKET + "/groups?includeProperties=true");
  },
  fetchAllProperties: function fetchAllProperties() {
    return _q.default.Promise.all([this.fetchContactProperties(), this.fetchCompanyProperties(), this.fetchDealProperties(), this.fetchTicketProperties()]).then(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 4),
          contactProperties = _ref2[0],
          companyProperties = _ref2[1],
          dealProperties = _ref2[2],
          ticketProperties = _ref2[3];

      return (0, _immutable.fromJS)({
        CONTACT: contactProperties,
        COMPANY: companyProperties,
        DEAL: dealProperties,
        TICKET: ticketProperties
      });
    });
  }
};
exports.default = _default;
module.exports = exports.default;